import React, { createContext, useState, useEffect } from 'react'
import PropTypes from 'prop-types'

export const AGLContext = createContext()

export const AGLProvider = ({ children }) => {
  const [aglState, setAglState] = useState({
    token: null,
    orders: [], 
    processOrders: false, 
    orderIndex: 0,
    ordersDone: false
  })

  const aglListener = (event) => {
    for (let type in event.data) {
      const payload = event.data[type]
      switch (type) {
      case 'token':
        setAglState((ps) => ({
          ...ps,
          token: payload
        }))
        break
      case 'error':
        break
      case 'state':
        console.log('The state was received')
        break
      case 'actionExecuted': {
        console.log('The actionExecuted was received')
        const order = aglState.orders[aglState.orderIndex]
        if (payload) {
          console.log('---ORDER_MADE---', new Date())
          console.log('---ORDER_PAYLOAD---', payload)
          console.log('---ORDER_PLACED---', order)

          setAglState((ps) => ({
            ...ps,
            orders: [
              ...ps.orders.slice(0, aglState.orderIndex), 
              {
                ...order,
                ordered: true
              },
              ...ps.orders.slice(aglState.orderIndex + 1), 
            ],
            orderIndex: ps.orderIndex + 1
          }))
        } else {
          setAglState((ps) => ({
            ...ps,
            orderIndex: ps.orderIndex + 1
          }))
        }
      }
        break
      case 'errorCodes':
        console.log('The errorCodes was received')
        break
      default:  
        break
      }
    }
  }

  useEffect(() => {
    window.addEventListener('message', aglListener, false)

    window.parent.postMessage({
      action: 'Epic.Clinical.Informatics.Web.InitiateHandshake'
    }, '*')
  }, [])

  useEffect(() => {
    if (aglState.processOrders) {
      if (aglState.orderIndex < aglState.orders.length) {
        const order = aglState.orders[aglState.orderIndex]
        if (order.orderKey) {
          if (aglState.token) {
            window.parent.postMessage({
              token: aglState.token,
              action: 'Epic.Clinical.Informatics.Web.PostOrder',
              args: { OrderKey: order.orderKey }
            }, '*')
          } else {
            setAglState((ps) => ({
              ...ps,
              orders: [
                ...ps.orders.slice(0, aglState.orderIndex), 
                {
                  ...order,
                  ordered: true
                },
                ...ps.orders.slice(aglState.orderIndex + 1), 
              ],
              orderIndex: ps.orderIndex + 1
            }))
          }
        } else {
          setAglState((ps) => ({
            ...ps,
            orderIndex: ps.orderIndex + 1
          }))
        }
      } else {
        setAglState((ps) => ({
          ...ps,
          processOrders: false,
          ordersDone: true
        }))
      }
    }
  }, [aglState.processOrders, aglState.orderIndex])

  return (
    <AGLContext.Provider value={{ aglState, setAglState }}>
      {children}
    </AGLContext.Provider>
  )
}

AGLProvider.propTypes = {
  children: PropTypes.node.isRequired
}